import socketIo from 'socket.io-client';
import VIDABOO_CONSTANTS from '../config/consts';
import storageService from './storageService';

var fileScope = {};

// iharel todo: fix $rootScope and $q
const $rootScope = {};
const $q = {};

// const is_node = false;
const is_angular = true;
// if (is_node) {
//   fileScope.io = require("../../../../websocket-static-server/node_modules/socket.io-client");
//   fileScope.localStorage = {
//     getItem: function() {
//       return 1000;
//     }
//   };
// }
if (is_angular) {
  fileScope.io = socketIo;
  fileScope.storageService = storageService;
}
fileScope.WSService = function (VIDABOO_CONSTANTS) {
  var contScope = this;
  contScope.socket = null;
  contScope.socketEstablished = false;
  contScope.debugFunctions = [];
  contScope.connectionEventListeners = {};

  contScope.sendConnectionEvents = (event) => {
    console.debug(new Date() + ' Websocket event: ', event);
    Object.keys(contScope.connectionEventListeners).forEach((id) => {
      contScope.connectionEventListeners[id](event);
    });
  };
  return {
    addConnectionEventListener: function (callbackFunction) {
      const callbackFunctionId =
        new Date().getTime() + '_' + Math.floor(Math.random() * 1e8);
      // console.debug("adding connectionEventListener");
      contScope.connectionEventListeners[callbackFunctionId] = callbackFunction;
      return () => {
        delete contScope.connectionEventListeners[callbackFunctionId];
      };
    },
    socket: function () {
      return contScope.socket;
    },
    connect: function (data, onlyConnect) {
      // console.debug(data);
      console.debug('********* TRYING TO CONNECT ', onlyConnect);
      if (onlyConnect) {
        contScope.socket.connect();
        return;
      }
      // console.debug("VIDABOO_CONSTANTS.WEBSOCKET_HOST", VIDABOO_CONSTANTS.WEBSOCKET_HOST)

      // console.debug('connecting to socket: ' + data);
      if (contScope.socket === null || contScope.socket === undefined) {
        //console.debug('user connecting');

        contScope.socketEstablished = 'started';
        contScope.socket = fileScope.io.connect(
          VIDABOO_CONSTANTS.WEBSOCKET_HOST,
          {
            transports: ['websocket', 'polling'], // Use both transports,
            path: '/ws/socket.io/',
            query: {
              userId: data.userId,
              token: fileScope.storageService.getItem('token'),
            },
            withCredentials: false,
            pingTimeout: 10000,
            pingInterval: 60000,
          },
        );
        contScope.socket.data = data; // for ws_tests
        contScope.socket.on('disconnect', function () {
          contScope.socketEstablished = false;
          contScope.sendConnectionEvents(
            VIDABOO_CONSTANTS.WS_CONNECTION_STATES.DISCONNECTED,
          );
        });
        contScope.socket.on('connected', function () {
          // console.debug('connected with socketId: ' + JSON.stringify(data));
          contScope.socketEstablished = true;
          contScope.sendConnectionEvents(
            VIDABOO_CONSTANTS.WS_CONNECTION_STATES.CONNECTED,
          );
        });
      } else {
        // connecting after connection already previously established (for example, during login, moving from guest to user)
        if (contScope.socket.connected === false) {
          // socket was disconnected and now being connected again
          contScope.socket.connect();
          contScope.socketEstablished = true;
          console.debug('Error in WS: 102');
        } else {
          // ???
          alert('Connection is very unstable...');
          contScope.socket.removeAllListeners();
          contScope.socket.disconnect();

          // socketEstablished = false;
          //socket.connect();
          contScope.socketEstablished = 'started';
          contScope.socket = fileScope.io.connect(
            VIDABOO_CONSTANTS.WEBSOCKET_HOST,
            {
              transports: ['websocket', 'polling'], // Use both transports,
              path: '/ws/socket.io/',
              query: {
                userId: data.userId,
                token: fileScope.storageService.getItem('token'),
              },

              withCredentials: false,
              pingTimeout: 10000,
              pingInterval: 60000,
            },
          );

          contScope.socketEstablished = true;
        }
      }
    },
    on: function (eventName, callback) {
      if (contScope.socket !== undefined) {
        contScope.socket.on(eventName, function () {
          var args = arguments;

          callback.apply(contScope.socket, args);
        });
      }
    },
    off: function (eventName) {
      contScope.socket.off(eventName);
    },
    socketEstablished: function () {
      return contScope.socketEstablished;
    },
    emit: function (eventName, data) {
      contScope.socket.emit(eventName, data);
    },
    disconnect: function (onlyDisconnectSocket) {
      if (onlyDisconnectSocket) {
        if (contScope.socket !== undefined && contScope.socket !== null) {
          contScope.socket.disconnect();
          return;
        }
      }
      // intentional disconnection
      contScope.socketEstablished = false;

      if (contScope.socket !== undefined && contScope.socket !== null) {
        console.debug('removing listener');
        contScope.socket.removeAllListeners(); //CFW-184, comment this out for testing socket disconnection
        contScope.socket.disconnect();
        contScope.socket = null; //CFW-184, comment this out for testing socket disconnection
        console.debug('intentional disconnect');
      }
    },
  };
};
fileScope.ListeningRoomService = function (WSService) {
  // console.debug("listening room service");
  const contScope = {};
  contScope.initListeningRoomService = () => {
    contScope.permanentCallbackFunctions = {}; // {uniqueId:callbackFunction1, uniqueId2:callbackfunction2
    contScope.subscribedLRs = {}; // {roomId:joinRoomObj, roomId2: joinRoomObj2}
    contScope.publishLRs = {}; // {roomId:joinRoomObj, roomId2: joinRoomObj2}

    WSService.addConnectionEventListener((connectionEvent) => {
      console.debug('connectionEvent', connectionEvent);
      if (connectionEvent === 'connected') {
        WSService.on('messageFromListeningRoom', function (packetObject) {
          // console.debug(packetObject);
          // console.debug("messageFromListeningRoom", packetObject);
          // console.debug(
          //   "Received message from listening room. cb funcs: " +
          //     Object.keys(contScope.permanentCallbackFunctions).length
          // );
          Object.keys(contScope.permanentCallbackFunctions).forEach((id) => {
            contScope.permanentCallbackFunctions[id] && // added to fix a case where function was deleted during the forEach
              contScope.permanentCallbackFunctions[id](packetObject);
          });
        });
        // connect to all the subscribedLRs and publishLRs.
        Object.keys(contScope.subscribedLRs).forEach((roomId) => {
          contScope.connectToListeningRoomAsSubscriber(
            contScope.subscribedLRs[roomId],
          );
        });
        Object.keys(contScope.publishLRs).forEach((roomId) => {
          // console.debug("roomId", roomId);
          contScope.connectToListeningRoomAsPublisher(
            contScope.publishLRs[roomId],
          );
        });
      } else if (
        connectionEvent === VIDABOO_CONSTANTS.WS_CONNECTION_STATES.DISCONNECTED
      ) {
        WSService.off('messageFromListeningRoom');
      }
    });
  };
  contScope.removeAllListeningRooms = () => {
    contScope.subscribedLRs = {};
    contScope.publishLRs = {};
    contScope.permanentCallbackFunctions = {};
  };

  contScope.connectToListeningRoomAsSubscriber = (joinRoomObj) => {
    if (WSService.socketEstablished() === true) {
      // only if websocket is up we try to emit.
      WSService.emit('joinListeningRoomAsSubscriber', joinRoomObj);
    }
  };
  contScope.connectToListeningRoomAsPublisher = (joinRoomObj) => {
    if (WSService.socketEstablished() === true) {
      // only if websocket is up we try to emit.
      WSService.emit('joinListeningRoomAsPublisher', joinRoomObj);
    }
  };
  contScope.initListeningRoomService();

  return {
    connectToMyListeningRoom: function (userId, token) {
      if (token === null || token === undefined) {
        token = fileScope.storageService.getItem('token');
      }
      var joinRoomObj = {
        roomId: userId,
        requesterUserId: userId,
        token: token,
      };
      contScope.connectToListeningRoomAsSubscriber(joinRoomObj);
      contScope.subscribedLRs[joinRoomObj.roomId] = joinRoomObj;
      return () => {
        // function that removes this subscription.
        delete contScope.subscribedLRs[joinRoomObj.roomId];
      };
    },
    connectToPeerListeningRoom: function (roomId, userId, token) {
      if (token === null || token === undefined) {
        token = fileScope.storageService.getItem('token');
      }
      var joinRoomObj = {
        roomId: roomId,
        requesterUserId: userId,
        token: token,
      };
      // console.debug('JOINING_LISTENING_ROOM Publisher: ' + roomId);
      contScope.connectToListeningRoomAsPublisher(joinRoomObj);
      contScope.publishLRs[joinRoomObj.roomId] = joinRoomObj;
      return () => {
        // function that removes this subscription.
        delete contScope.publishLRs[joinRoomObj.roomId];
      };
    },
    publishToListeningRoom: function (
      content,
      userId,
      targetRoomId,
      messageType,
      token,
    ) {
      if (token === null || token === undefined) {
        token = fileScope.storageService.getItem('token');
      }
      const packetObject = {
        messageType: messageType,
        senderUserId: userId,
        content: content,
        targetRoomId: targetRoomId,
        token: token,
      };
      WSService.emit('publishToListeningRoom', packetObject);
    },
    doWhenMessageReceivedFromListeningRoom: (callbackFunction) => {
      const callbackFunctionId =
        new Date().getTime() + '_' + Math.floor(Math.random() * 1e8);
      contScope.permanentCallbackFunctions[callbackFunctionId] =
        callbackFunction;
      return () => {
        delete contScope.permanentCallbackFunctions[callbackFunctionId];
      };
    },
    clearAllCallbackFunctions: () => {
      contScope.removeAllListeningRooms();
    },
  };
};
fileScope.ShoutingRoomService = function (WSService) {
  const contScope = {};
  contScope.subscribedSRs = {}; // {roomId:joinRoomObj, roomId2: joinRoomObj2}
  contScope.publishSRs = {}; // {roomId:joinRoomObj, roomId2: joinRoomObj2}
  contScope.permanentCallbackFunctions = {}; // {roomId1: {uniqueId:callbackFunction1, uniqueId2:callbackfunction2}

  contScope.initShoutingRoomService = () => {
    contScope.permanentCallbackFunctions = {};
    contScope.subscribedSRs = {};
    contScope.publishSRs = {};
    WSService.addConnectionEventListener((connectionEvent) => {
      if (
        connectionEvent === VIDABOO_CONSTANTS.WS_CONNECTION_STATES.CONNECTED
      ) {
        WSService.on('messageFromShoutingRoom', function (packetObject) {
          // console.debug("messageFromShoutingRoom", packetObject);
          // console.debug("messageFromShoutingRoom");

          // console.debug(
          //   "Received message from Shouting room. Callback rooms for roomId: " +
          //     packetObject.senderUserId +
          //     " : " +
          //     Object.keys(contScope.permanentCallbackFunctions).length
          // );
          const roomId = packetObject.senderUserId; // in shouting room, roomId is equal to the sender userId. Exception: server ack messages
          const functionsHash = contScope.permanentCallbackFunctions[roomId];
          if (functionsHash !== undefined && functionsHash !== null) {
            Object.values(functionsHash).forEach((func) => {
              func(packetObject);
            });
          }
        });

        // connect to all the subscribedSRs and publishSRs.
        Object.keys(contScope.subscribedSRs).forEach((roomId) => {
          contScope.connectToShoutingRoomAsSubscriber(
            contScope.subscribedSRs[roomId],
          );
        });
        Object.keys(contScope.publishSRs).forEach((roomId) => {
          contScope.connectToShoutingRoomAsPublisher(
            contScope.publishSRs[roomId],
          );
        });
      } else if (
        connectionEvent === VIDABOO_CONSTANTS.WS_CONNECTION_STATES.DISCONNECTED
      ) {
        WSService.off('messageFromShoutingRoom');
      }
    });
  };
  contScope.removeAllShoutingRooms = () => {
    contScope.subscribedSRs = {};
    contScope.publishSRs = {};
  };
  contScope.connectToShoutingRoomAsSubscriber = (joinRoomObj) => {
    if (WSService.socketEstablished() === true) {
      // only if websocket is up we try to emit.

      WSService.emit('joinShoutingRoomAsSubscriber', joinRoomObj);
    }
  };
  contScope.connectToShoutingRoomAsPublisher = (joinRoomObj) => {
    if (WSService.socketEstablished() === true) {
      // only if websocket is up we try to emit.
      WSService.emit('joinShoutingRoomAsPublisher', joinRoomObj);
    }
  };

  contScope.initShoutingRoomService();
  return {
    connectToMyShoutingRoom: function (userId, token) {
      // userId for future: it's the indication that this is the mentor
      if (token === null || token === undefined) {
        token = fileScope.storageService.getItem('token');
      }
      const joinRoomObj = {
        roomId: userId,
        requesterUserId: userId,
        token: token,
      };
      contScope.connectToShoutingRoomAsPublisher(joinRoomObj);
      contScope.publishSRs[joinRoomObj.roomId] = joinRoomObj;
      return () => {
        // function that removes this subscription.
        delete contScope.publishSRs[joinRoomObj.roomId];
      };
    },
    connectToPeerShoutingRoom: function (peerUserId, userId, token) {
      // console.debug('connecting to peer: ' + peerUserId);
      if (token === null || token === undefined) {
        token = fileScope.storageService.getItem('token');
      }

      const joinRoomObj = {
        roomId: peerUserId,
        requesterUserId: userId,
        token: token,
      };
      //console.debug(joinRoomObj);
      contScope.connectToShoutingRoomAsSubscriber(joinRoomObj);
      contScope.subscribedSRs[joinRoomObj.roomId] = joinRoomObj;
      return () => {
        // function that removes this subscription.
        delete contScope.subscribedSRs[joinRoomObj.roomId];
      };
    },
    publishToShoutingRoom: function (content, messageType, senderUserId) {
      if (content) content.senderProfileName = 'guest_user'; // todomobile - remove
      const packetObject = {
        messageType: messageType,
        senderUserId: senderUserId,
        content: content,
      };
      WSService.emit('publishToShoutingRoom', packetObject);
    },

    doWhenMessageReceivedFromShoutingRoom: function (roomId, callbackFunction) {
      // registers callback function(s) per roomId. triggers the corresponding callback function once a message is received.
      if (contScope.permanentCallbackFunctions[roomId] === undefined) {
        contScope.permanentCallbackFunctions[roomId] = {};
      }
      const callBackFunctions = contScope.permanentCallbackFunctions[roomId];
      const callbackFunctionId =
        new Date().getTime() + '_' + Math.floor(Math.random() * 1e8);
      callBackFunctions[callbackFunctionId] = callbackFunction;
      return () => {
        contScope.permanentCallbackFunctions[roomId] &&
          delete contScope.permanentCallbackFunctions[roomId][
            callbackFunctionId
          ];
      };
    },

    clearAllCallbackFunctions: function () {
      contScope.subscribedSRs = {};
      contScope.publishSRs = {};
      contScope.permanentCallbackFunctions = {};
    },
  };
};

fileScope.PrivateRoomService = function (WSService) {
  const contScope = {};
  contScope.subscribedPRs = {}; // {roomId:joinRoomObj, roomId2: joinRoomObj2}
  // contScope.publishPRs = {}; // {roomId:joinRoomObj, roomId2: joinRoomObj2}
  contScope.permanentPRCallbackFunctions = {}; // {roomId1: {uniqueId:callbackFunction1, uniqueId2:callbackfunction2}

  contScope.initPrivateRoomService = () => {
    contScope.permanentPRCallbackFunctions = {}; // {uniqueId:callbackFunction1, uniqueId2:callbackfunction2
    contScope.subscribedPRs = {}; // {roomId:joinRoomObj, roomId2: joinRoomObj2}
    // contScope.publishPRs = {}; // {roomId:joinRoomObj, roomId2: joinRoomObj2}
    WSService.addConnectionEventListener((connectionEvent) => {
      if (connectionEvent === 'connected') {
        WSService.on('messageFromPrivateRoom', (packetObject) => {
          console.debug('messageFromPrivateRoom packetObject', packetObject);
          // console.debug(
          //   'messageFromPrivateRoom contScope.permanentCallbackFunctions',
          //   contScope.permanentPRCallbackFunctions,
          // );
          const roomId = packetObject.targetRoomId;

          let callBackFunctionsHash =
            contScope.permanentPRCallbackFunctions[roomId];
          if (callBackFunctionsHash) {
            Object.values(callBackFunctionsHash).forEach((callbackFunction) => {
              callbackFunction(packetObject);
            });
          }
          callBackFunctionsHash =
            contScope.permanentPRCallbackFunctions[
              VIDABOO_CONSTANTS.WEBSOCKET_PRIVATE_ROOM_ALL
            ];
          if (callBackFunctionsHash) {
            Object.values(callBackFunctionsHash).forEach((callbackFunction) => {
              callbackFunction(packetObject);
            });
          }
        });
        // connect to all the subscribedPRs and publishPRs.
        Object.keys(contScope.subscribedPRs).forEach((roomId) => {
          contScope.connectToPrivateRoom(contScope.subscribedPRs[roomId]);
        });
      } else if (
        connectionEvent === VIDABOO_CONSTANTS.WS_CONNECTION_STATES.DISCONNECTED
      ) {
        WSService.off('messageFromPrivateRoom');
      }
    });
  };
  contScope.removeAllPrivateRooms = () => {
    contScope.subscribedPRs = {};
    contScope.permanentPRCallbackFunctions = {};
  };

  contScope.connectToPrivateRoom = (joinRoomObj) => {
    if (WSService.socketEstablished() === true) {
      // only if websocket is up we try to emit.
      WSService.emit('joinPrivateRoom', joinRoomObj);
    }
  };

  contScope.initPrivateRoomService();

  return {
    connectToPrivateRoom: (roomId, userId, token) => {
      if (!token) {
        token = fileScope.storageService.getItem('token');
      }
      const joinRoomObj = {
        roomId: roomId,
        requesterUserId: userId,
        token: token,
      };
      contScope.connectToPrivateRoom(joinRoomObj);
      contScope.subscribedPRs[joinRoomObj.roomId] = joinRoomObj;
      return () => {
        // function that removes this subscription.
        console.debug(
          'Removing subscription to private room: ' + joinRoomObj.roomId,
        );
        delete contScope.subscribedPRs[joinRoomObj.roomId];
      };
    },

    publishToPrivateRoom: (
      content,
      userId,
      targetRoomId,
      messageType,
      token,
    ) => {
      if (token === null || token === undefined) {
        token = fileScope.storageService.getItem('token');
      }
      const packetObject = {
        messageType: messageType,
        senderUserId: userId,
        content: content,
        targetRoomId: targetRoomId,
        token: token,
      };
      WSService.emit('publishToPrivateRoom', packetObject);
    },
    doWhenMessageReceivedFromPrivateRoom: (roomId, callbackFunction) => {
      if (!roomId) roomId = VIDABOO_CONSTANTS.WEBSOCKET_PRIVATE_ROOM_ALL;
      if (!contScope.permanentPRCallbackFunctions[roomId]) {
        contScope.permanentPRCallbackFunctions[roomId] = {};
      }
      const callbackFunctionId =
        new Date().getTime() + '_' + Math.floor(Math.random() * 1e8);
      const callBackFunctions = contScope.permanentPRCallbackFunctions[roomId];

      callBackFunctions[callbackFunctionId] = callbackFunction;
      return () => {
        if (contScope.permanentPRCallbackFunctions[roomId]) {
          delete contScope.permanentPRCallbackFunctions[roomId][
            callbackFunctionId
          ];
        }
        console.debug('Removing subscription to private room: ALL');
      };
    },
    clearAllCallbackFunctions: function () {
      contScope.removeAllPrivateRooms();
    },
  };
};

export const WSService = fileScope.WSService(VIDABOO_CONSTANTS, $rootScope, $q);
export const ListeningRoomService = fileScope.ListeningRoomService(WSService);
export const ShoutingRoomService = fileScope.ShoutingRoomService(WSService);
export const PrivateRoomService = fileScope.PrivateRoomService(WSService);

const websocketService = {
  WSService: WSService,
  ListeningRoomService: ListeningRoomService,
  ShoutingRoomService: ShoutingRoomService,
  PrivateRoomService: PrivateRoomService,
};
export default websocketService;
